
class ProductCardForm extends HTMLElement {
  constructor() {
    super();

    this.productCard = this.closest('.product-card');
    this.form = this.querySelector("form");
    this.button = this.form.querySelector('button[name="add"]');
    this.form.addEventListener("submit", this.onSubmit.bind(this));
    this.quickViewContent = this.closest(".quick-view-content");

    this.handleVariantSelector();
    this.handleOptionsSelector();
  }

  async onSubmit(event) {
    event.preventDefault();

    const freeGifts = this.closest("sticky-atc") ? document.querySelector("free-gifts") : null;
    if (freeGifts && !freeGifts.areSelectionsComplete()) {
      freeGifts.focusIncomplete();
      freeGifts.syncAtcButtons();
      return;
    }

    this.button.classList.add("loading");
    this.button.disabled = true;
    this.button.setAttribute("aria-busy", "true");

    const formData = new FormData(this.form);

    // Sticky ATC on the product page should include free gifts with the main product.
    if (freeGifts) {
      freeGifts.applyToFormData?.(formData);
    }

    await document.querySelector("cart-component").add(formData);

    this.button.classList.remove("loading");
    this.button.disabled = false;
    this.button.setAttribute("aria-busy", "false");
    freeGifts?.syncAtcButtons?.();
  }

  handleVariantSelector() {
    const selector = this.querySelector("select[name='id']");
    if (!selector) return;
    
    selector.addEventListener("change", () => {
      const selectedOption = selector.options[selector.selectedIndex];
      const variantImage = selectedOption.dataset.variantImage;

      // Require-selection mode: enable the add-to-cart button only once a real
      // variant is picked (the placeholder option has an empty value).
      if (this.button) {
        if (selector.value) {
          this.button.disabled = false;
          if (this.button.dataset.textAdd) this.button.textContent = this.button.dataset.textAdd;
        } else {
          this.button.disabled = true;
          if (this.button.dataset.textChoose) this.button.textContent = this.button.dataset.textChoose;
        }
      }

      if (this.productCard) {
        if (variantImage.length) {
          this.productCard.querySelector('.img-wrapper img').src = variantImage;
        }

        this.productCard.querySelectorAll('input[name*="color-swatch"]').forEach((input) => {
          if (selectedOption.innerText.includes(input.value)) {
            input.checked = true;
          } else {
            input.checked = false;
          }
        });

        this.appendVariantIdToUrl(selector.value);
      }
    });
  }

  handleOptionsSelector() {
    const script = this.querySelector("[data-product-variants-json]");
    if (!script) return;

    const variantsData = JSON.parse(script.textContent);
    // console.log("Variants data:", variantsData);

    this.querySelectorAll('select[name*="option"]').forEach((select) => {
      select.addEventListener("change", () => {

        const selectedOptions = Array.from(this.querySelectorAll('select[name*="option"]'))
          .map((s) => s.value)

        // console.log("Selected options:", selectedOptions);

        const selectedVariant = variantsData.find((variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions));
        // console.log("Selected variant", selectedVariant);

        const atcBtn = this.querySelector("button[name='add']");

        if (selectedVariant) {
          this.querySelector('[name="id"]').value = selectedVariant.id;

          atcBtn.textContent = selectedVariant.available ? atcBtn.dataset.textAdd : atcBtn.dataset.textSoldOut;
          atcBtn.disabled = !selectedVariant.available;
          
          let priceContainer

          if (this.productCard) {
            priceContainer = this.productCard.querySelector(".price");
          } else if (this.quickViewContent) {
            priceContainer = this.quickViewContent.querySelector(".price");
          }

          if (priceContainer) {
            priceContainer.setAttribute("data-has-price-compare", selectedVariant.compare_at_price > selectedVariant.price);
            priceContainer.setAttribute("data-price-varies", false);

            priceContainer.querySelectorAll("[data-compare-price]").forEach((elem) => {
              elem.textContent = window.Shopify.formatMoney(selectedVariant.compare_at_price);
            });

            priceContainer.querySelectorAll("[data-price]").forEach((elem) => {
              elem.textContent = window.Shopify.formatMoney(selectedVariant.price);
            });
          }
          
          const variantImage = selectedVariant.featured_image ? selectedVariant.featured_image.src : null;
          
          if (variantImage) {
            // console.log("Variant image:", variantImage);
            if (this.productCard) {
              const productImage = this.productCard.querySelector(".img-wrapper img");
              productImage.src = window.Shopify.resizeImage(variantImage, `${this.getVariantImageSize().width}x${this.getVariantImageSize().height}`, "center");
            } else if (this.quickViewContent) {
              let index =  0

              if (selectedVariant.featured_image) {
                index = selectedVariant.featured_image.position - 1;
              }

              const slideshow = this.quickViewContent.querySelector("slideshow-component");

              if (slideshow) {
                slideshow.go(index);
              }
            }
          }

          this.querySelectorAll('input[name*="color-swatch"]').forEach((input) => {
            if (selectedOptions.includes(input.value)) {
              input.checked = true;
            } else {
              input.checked = false;
            }
          });
        } else {
          atcBtn.textContent = atcBtn.dataset.textUnavailable;
          atcBtn.disabled = true;
        }
      })
    })
  }

  getVariantImageSize() {
    let imgWidth, imgHeight;

    switch (this.dataset.imgRatio) {
      case "adapt":
        imgWidth = 480;
        imgHeight = '';
        break;
      case "square":
        imgWidth = 480;
        imgHeight = 480;
        break;
      case "portrait":
        imgWidth = 480
        imgHeight = Math.round(480 * 4 / 3);
        break;
    }
    
    return { width: imgWidth, height: imgHeight };
  }

  appendVariantIdToUrl(variantId) {
    const link = this.closest('.product-card').querySelector(".product-card-link");
    if (!link) return;

    const url = new URL(link.href);
    url.searchParams.set("variant", variantId);
    link.href = url.toString();
  }
}
customElements.define("product-card-form", ProductCardForm);

class ProductCardColorSwatches extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input[name*="color-swatch"]').forEach((input) => {
      input.addEventListener("change", () => {
        this.appendVariantIdToUrl(input.dataset.variantId);
  
        const productCard = this.closest('.product-card');

        if (productCard) {
          const variantImage = (input.dataset.variantImage || "").trim();
          if (variantImage) {
            const productImage = productCard.querySelector(".img-wrapper img");
            if (productImage) {
              productImage.src = variantImage;
            }
          }

          const variantInput = productCard.querySelector(".shopify-product-form [name='id']");
          if (variantInput) {
            variantInput.value = input.dataset.variantId;
          }
    
          const colorOption = productCard.querySelector(`.shopify-product-form select[data-option-name*="${input.dataset.optionName}"]`);

          if (colorOption) {
            colorOption.value = input.value;
          }
        }
      });
    });
  }

  appendVariantIdToUrl(variantId) {
    const link = this.closest('.product-card').querySelector(".product-card-link");
    if (!link) return;

    const url = new URL(link.href);
    url.searchParams.set("variant", variantId);
    link.href = url.toString();
  }
}
customElements.define("product-card-color-swatches", ProductCardColorSwatches);

class QuickViewModal extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.closest("dialog");
    this.productData = null;
    this.productUrl = null;
    this.optionsNode = null;
    this.isCompact = false;
    this._latestLoadUrl = null;
    this._productJsCache = new Map();
    this._pageEnhancementCache = new Map();
    this._prefetchInFlight = new Set();
    // Per-variant image srcs sourced from the product page's variant media
    // templates (custom.media metafield). Keyed by variant id.
    this.variantMedia = {};
    // Shared images shown for every variant (non-variant-specific gallery slides).
    this.commonMedia = [];

    this.onQuickViewClick = async (event) => {
      const btn = event.target.closest("[name='quick-view']");

      if (btn) {
        event.preventDefault();
        this.isCompact = btn.hasAttribute("data-quick-view-compact");
        this._latestLoadUrl = btn.dataset.productUrl;
        btn.classList.add("loading");
        btn.disabled = true;
        btn.setAttribute("aria-busy", "true");

        await this.openQuickView(btn.dataset.productUrl);

        btn.classList.remove("loading");
        btn.disabled = false;
        btn.setAttribute("aria-busy", "false");
      }
    };
    document.addEventListener("click", this.onQuickViewClick);

    this.onQuickViewPrefetch = (event) => {
      const btn = event.target.closest("[name='quick-view']");
      if (btn?.dataset.productUrl) this.prefetch(btn.dataset.productUrl);
    };
    document.addEventListener("pointerenter", this.onQuickViewPrefetch, true);
    document.addEventListener("focusin", this.onQuickViewPrefetch, true);

    this.onDialogClose = (event) => {
      if (event.detail.dialog.id === "quick-view-dialog") {
        this.clearQuickView();
      }
    };
    window.addEventListener("dialog:close", this.onDialogClose);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onQuickViewClick);
    document.removeEventListener("pointerenter", this.onQuickViewPrefetch, true);
    document.removeEventListener("focusin", this.onQuickViewPrefetch, true);
    window.removeEventListener("dialog:close", this.onDialogClose);
  }

  prefetch(url) {
    if (!url || this._prefetchInFlight.has(url)) return;
    if (this._productJsCache.has(url) && this._pageEnhancementCache.has(url)) return;

    this._prefetchInFlight.add(url);

    const tasks = [];

    if (!this._productJsCache.has(url)) {
      tasks.push(
        fetch(`${url}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .then((data) => {
            if (data) this._productJsCache.set(url, data);
          }),
      );
    }

    if (!this._pageEnhancementCache.has(url)) {
      tasks.push(
        this.fetchProductPageEnhancement(url).then((enhancement) => {
          if (enhancement) this.cachePageEnhancement(url, enhancement);
        }),
      );
    }

    Promise.all(tasks).finally(() => this._prefetchInFlight.delete(url));
  }

  cachePageEnhancement(url, enhancement) {
    this._pageEnhancementCache.set(url, {
      optionsHtml: enhancement.optionsNode?.outerHTML ?? null,
      variantMedia: enhancement.variantMedia,
      commonMedia: enhancement.commonMedia,
    });
  }

  getCachedPageEnhancement(url) {
    const cached = this._pageEnhancementCache.get(url);
    if (!cached) return null;

    let optionsNode = null;
    if (cached.optionsHtml) {
      const pageDoc = new DOMParser().parseFromString(cached.optionsHtml, "text/html");
      optionsNode = pageDoc.querySelector("product-options");
      optionsNode?.querySelectorAll("script[data-product-variants-json]").forEach((el) => {
        el.textContent = "[]";
      });
    }

    return {
      optionsNode,
      variantMedia: { ...cached.variantMedia },
      commonMedia: [...cached.commonMedia],
    };
  }

  async openQuickView(url) {
    const loadUrl = url;

    this.ensureProductStyles();

    const pagePromise = (async () => {
      const cached = this.getCachedPageEnhancement(loadUrl);
      if (cached) return cached;

      const enhancement = await this.fetchProductPageEnhancement(loadUrl);
      if (enhancement) this.cachePageEnhancement(loadUrl, enhancement);
      return enhancement;
    })();

    let data = this._productJsCache.get(loadUrl);

    if (!data) {
      const response = await fetch(`${loadUrl}.js`);
      data = await response.json();

      if (!response.ok) {
        console.error("Failed to fetch product data:", response.statusText);
        return;
      }

      this._productJsCache.set(loadUrl, data);
    }

    if (this._latestLoadUrl !== loadUrl) return;

    const cachedEnhancement = this.getCachedPageEnhancement(loadUrl);

    this.productData = data;
    this.productUrl = loadUrl;
    this.optionsNode = cachedEnhancement?.optionsNode ?? null;
    this.variantMedia = cachedEnhancement?.variantMedia ?? {};
    this.commonMedia = cachedEnhancement?.commonMedia ?? [];

    this.buildQuickView();

    const content = this.querySelector(".quick-view-content");
    const showOptions = data.variants.length > 1;
    const optionsPending = showOptions && !this.optionsNode;

    this.mountOptions(content, data, { pending: optionsPending });

    if (!optionsPending) {
      this.syncQuickViewVariant(content, data);
    }

    this.dialog.classList.toggle("is-compact", this.isCompact);
    this.dialog.showModal();

    void this.applyPageEnhancement(pagePromise, loadUrl);
  }

  async applyPageEnhancement(pagePromise, loadUrl) {
    const pageEnhancement = await pagePromise;

    if (this._latestLoadUrl !== loadUrl || !this.productData) return;

    const content = this.querySelector(".quick-view-content");
    if (!content) return;

    if (pageEnhancement?.optionsNode) {
      this.optionsNode = pageEnhancement.optionsNode;
      this.variantMedia = pageEnhancement.variantMedia ?? {};
      this.commonMedia = pageEnhancement.commonMedia ?? {};

      const optionsMount = content.querySelector(".product-block[data-type='options']");
      const hasMountedOptions = optionsMount && !optionsMount.querySelector(".quick-view-options-loading");

      if (!hasMountedOptions || optionsMount.querySelector("fieldset") == null) {
        this.mountOptions(content, this.productData);
      }

      this.syncQuickViewVariant(content, this.productData);
      return;
    }

    if (this.productData.variants.length > 1) {
      this.mountOptions(content, this.productData);
      this.syncQuickViewVariant(content, this.productData);
    }
  }

  async fetchProductPageEnhancement(productUrl) {
    try {
      const pageRes = await fetch(productUrl);
      if (!pageRes.ok) return null;

      const pageHtml = await pageRes.text();
      const pageDoc = new DOMParser().parseFromString(pageHtml, "text/html");
      const { variantMedia, commonMedia } = this.extractVariantMediaFromDoc(pageDoc);

      const pageNode = pageDoc.querySelector("product-options");
      if (pageNode) {
        pageNode.querySelectorAll("script[data-product-variants-json]").forEach((el) => {
          el.textContent = "[]";
        });
      }

      return {
        optionsNode: pageNode,
        variantMedia,
        commonMedia,
      };
    } catch (error) {
      console.error("Failed to fetch product options:", error);
    }

    return null;
  }

  ensureProductStyles() {
    if (document.getElementById("quick-view-product-css")) return;
    const href = this.dataset.productCss;
    if (!href) return;
    const link = document.createElement("link");
    link.id = "quick-view-product-css";
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  }

  extractVariantMediaFromDoc(pageDoc) {
    const variantMedia = {};
    const commonMedia = [];

    const templates = pageDoc.querySelectorAll("template[data-variant-slides]");
    if (templates.length) {
      templates.forEach((tpl) => {
        const id = tpl.getAttribute("data-variant-slides");
        if (!id) return;

        const srcs = Array.from(tpl.content.querySelectorAll("img"))
          .map((img) => img.getAttribute("src"))
          .filter(Boolean);

        if (srcs.length) variantMedia[id] = srcs;
      });

      const commonImgs = pageDoc.querySelectorAll(
        ".product-media-gallery-track .product-media-gallery-slide:not([data-variant-specific]) img",
      );
      commonMedia.push(
        ...Array.from(commonImgs)
          .map((img) => img.getAttribute("src"))
          .filter(Boolean),
      );
    }

    return { variantMedia, commonMedia };
  }

  hasVariantMedia() {
    return Object.keys(this.variantMedia).length > 0;
  }

  // Compose a variant's gallery: its own images first, then shared media,
  // de-duplicated by base URL. Falls back to all product images.
  imagesForVariant(variant) {
    const specific = (variant && this.variantMedia[String(variant.id)]) || [];
    const common = this.commonMedia || [];

    const seen = new Set();
    const images = [];
    [...specific, ...common].forEach((src) => {
      const base = String(src).split("?")[0];
      if (seen.has(base)) return;
      seen.add(base);
      images.push(src);
    });

    return images.length ? images : this.productData.images;
  }

  getQuickViewImgDims() {
    const base = this.isCompact ? 200 : 480;

    switch (this.dataset.imgRatio) {
      case "square":
        return { imgWidth: base, imgHeight: base };
      case "portrait":
        return { imgWidth: base, imgHeight: Math.round((base * 4) / 3) };
      case "adapt":
      default:
        return { imgWidth: base, imgHeight: "" };
    }
  }

  buildSlideshowMarkup(images, title) {
    const { imgWidth, imgHeight } = this.getQuickViewImgDims();
    const escapeAttr = (str) =>
      String(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");

    const slides = images
      .map((image, index) => {
        const base = String(image).split("?")[0];
        const imgSrc = window.Shopify.resizeImage(base, `${imgWidth}x${imgHeight}`, "center");
        return `
        <div class="slideshow-slide" role="tabpanel" aria-roledescription="slide" aria-label="Slide ${index + 1}">
          <img src="${imgSrc}" class="img-fluid" alt="Image ${index + 1}" width="${imgWidth}" height="${imgHeight}" loading="eager">
        </div>`;
      })
      .join("");

    return `
      <slideshow-component class="slideshow" style="--speed: 300ms;" role="region" aria-label="Slideshow of ${escapeAttr(title)}" aria-roledescription="slideshow">
        <button class="slideshow-control" name="previous" type="button" aria-label="Previous slide">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="svg-icon-chevron-left" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"></path></svg>
        </button>
        <div class="slideshow-track" aria-live="polite" aria-atomic="true">${slides}</div>
        <button class="slideshow-control" name="next" type="button" aria-label="Next slide">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="svg-icon-chevron-right" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"></path></svg>
        </button>
        <div class="slideshow-pagination" data-pagination-type="fraction">
          <span>1 / ${images.length}</span>
        </div>
      </slideshow-component>`;
  }

  buildQuickView() {
    const content = this.querySelector(".quick-view-content");
    const product = this.productData;

    // Seed the gallery with the first variant's own media when available;
    // syncQuickViewVariant will swap it to match the actually-selected variant.
    const initialImages = this.hasVariantMedia()
      ? this.imagesForVariant(product.variants[0])
      : product.images;

    const showOptions = product.variants.length > 1;

    // When the merchant requires a manual selection, don't pre-pick a variant:
    // leave the hidden id empty and keep the button disabled until the shopper
    // chooses every option.
    const requireSelection = document.body.dataset.requireVariantSelection === "true";
    const preselect = !requireSelection || !showOptions;
    const firstVariant = product.variants[0];

    content.innerHTML = `
      <div class="quick-view-content-left">
        ${this.buildSlideshowMarkup(initialImages, product.title)}
      </div>
      <div class="quick-view-content-right">
        <h2 class="heading h3"><a href="${product.url}">${product.title}</a></h2>
        <div class="price fs-lg" data-has-price-compare="${product.compare_at_price > product.price ? "true" : "false"}" data-price-varies="${product.price_varies ? "true" : "false"}">
          <s class="price-compare">
            <span class="visually-hidden"> ${this.dataset.textRegularPrice} &nbsp; </span>
            <span data-compare-price>${window.Shopify.formatMoney(product.compare_at_price)}</span>
          </s>
          <span class="price-sale">
            <span class="visually-hidden"> ${this.dataset.textSalePrice} &nbsp; </span>
            <span class="price-from">${this.dataset.textPriceFrom}</span>
            <span data-price>${window.Shopify.formatMoney(product.price)}</span>
          </span>
          <span class="price-regular">
            <span class="price-from">${this.dataset.textPriceFrom}</span>
            <span data-price>${window.Shopify.formatMoney(product.price)}</span>
          </span>
        </div>
        <product-card-form class="product-card-form">
          <form method="post" action="${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"}cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" data-productid="${product.id}">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" value="${preselect ? firstVariant.id : ""}">
            <div class="quick-view-content-product-options product" ${showOptions ? "" : "hidden"}>
              <div class="product-block" data-type="options"></div>
            </div>
            <button class="btn btn-primary btn-full" type="submit" name="add" data-text-add="${this.dataset.textAddToCart}" data-text-sold-out="${this.dataset.textSoldOut}" data-text-unavailable="${this.dataset.textUnavailable}" data-text-choose="${this.dataset.textChoose || ""}" ${preselect ? (firstVariant.available ? "" : "disabled") : "disabled"}>
              ${preselect ? (firstVariant.available ? this.dataset.textAddToCart : this.dataset.textSoldOut) : (this.dataset.textChoose || this.dataset.textAddToCart)}
            </button>
            <script data-product-variants-json type="application/json">${JSON.stringify(product.variants)}</script>
          </form>
        </product-card-form>
        <a href="${product.url}" class="btn btn-link btn-sm btn-full">${this.dataset.textProductDetails}</a>
      </div>
    `;
  }

  mountOptions(content, product, { pending = false } = {}) {
    const optionsMount = content.querySelector(".product-block[data-type='options']");
    if (!optionsMount) return;

    content.querySelector(".quick-view-content-product-options")?.removeAttribute("data-qv-options-bound");
    optionsMount.innerHTML = "";

    if (this.optionsNode) {
      this.mountProductOptionsMarkup(optionsMount, this.optionsNode, product);
    } else if (pending) {
      optionsMount.innerHTML =
        '<div class="quick-view-options-loading" aria-live="polite" aria-busy="true"><span class="loading-spinner"></span></div>';
      return;
    } else {
      optionsMount.innerHTML = this.buildFallbackSelectOptions(product);
    }

    this.attachOptionListeners(content, product);
  }

  mountProductOptionsMarkup(optionsMount, optionsNode, product) {
    const fieldsets = optionsNode.querySelectorAll(":scope > fieldset");
    const uid = `qv-${product.id}`;

    if (fieldsets.length) {
      fieldsets.forEach((fieldset) => {
        const clone = document.importNode(fieldset, true);
        this.rewriteQuickViewOptionIds(clone, uid);
        optionsMount.appendChild(clone);
      });
      return;
    }

    const clone = document.importNode(optionsNode, true);
    this.rewriteQuickViewOptionIds(clone, uid);
    optionsMount.appendChild(clone);
  }

  rewriteQuickViewOptionIds(root, uid) {
    root.querySelectorAll("[id]").forEach((el) => {
      const oldId = el.id;
      if (!oldId || oldId.endsWith(`-${uid}`)) return;

      const newId = `${oldId}-${uid}`;
      root.querySelectorAll(`label[for="${oldId}"]`).forEach((label) => {
        label.setAttribute("for", newId);
      });
      el.id = newId;
    });

    root.querySelectorAll('input[type="radio"], select').forEach((el) => {
      if (!el.name || el.name.endsWith(`-${uid}`)) return;
      el.name = `${el.name}-${uid}`;
    });
  }

  attachOptionListeners(content, product) {
    const optionsRoot = content.querySelector(".quick-view-content-product-options");
    if (!optionsRoot) return;

    if (optionsRoot.dataset.qvOptionsBound === "true") return;
    optionsRoot.dataset.qvOptionsBound = "true";

    optionsRoot.addEventListener("change", (event) => {
      if (!event.target.matches("input[type='radio'], select")) return;
      this.syncQuickViewVariant(content, product);
    });
  }

  buildFallbackSelectOptions(product) {
    const optionsList =
      Array.isArray(product.options) && typeof product.options[0] === "string"
        ? product.options.map((name, index) => ({
            name,
            position: index + 1,
            values: [
              ...new Set(
                product.variants.map((variant) => variant[`option${index + 1}`]).filter(Boolean),
              ),
            ],
          }))
        : (product.options || []).map((option, index) => ({
            name: option.name,
            position: option.position || index + 1,
            values: option.values || [],
          }));

    return `
      <product-options>
        ${optionsList
          .map((option) => {
            const id = `option-${option.position}-qv-${product.id}`;
            return `
              <fieldset>
                <label class="form-label" for="${id}">${option.name}</label>
                <div class="select-wrapper">
                  <select id="${id}" name="${id}" class="select" data-option-position="${option.position}">
                    ${
                      document.body.dataset.requireVariantSelection === "true"
                        ? `<option value="" disabled selected data-placeholder-option>${this.dataset.textSelect || "Select"} ${option.name}</option>`
                        : ""
                    }
                    ${(option.values || [])
                      .map((value) => `<option value="${String(value).replace(/"/g, "&quot;")}">${value}</option>`)
                      .join("")}
                  </select>
                </div>
              </fieldset>`;
          })
          .join("")}
      </product-options>`;
  }

  getSelectedOptions(form) {
    const optionsRoot = form.querySelector(".quick-view-content-product-options");
    if (!optionsRoot) return [];

    const byPosition = {};

    optionsRoot.querySelectorAll("[data-option-position]").forEach((el) => {
      const pos = Number(el.getAttribute("data-option-position"));
      if (!pos) return;

      if (el.tagName === "SELECT") {
        byPosition[pos] = el.value;
      } else if (el.type === "radio" && el.checked) {
        byPosition[pos] = el.value;
      }
    });

    const positions = Object.keys(byPosition)
      .map(Number)
      .sort((a, b) => a - b);

    if (positions.length) {
      return positions.map((pos) => byPosition[pos]).filter((value) => value);
    }

    const selected = [];
    optionsRoot.querySelectorAll(".size-buttons, .color-swatches").forEach((group) => {
      const checked = group.querySelector("input[type='radio']:checked");
      if (checked) selected.push(checked.value);
    });

    return selected;
  }

  allQuickViewOptionsSelected(form) {
    const selects = form.querySelectorAll(
      ".quick-view-content-product-options select[data-option-position]",
    );
    for (const select of selects) {
      if (!select.value) return false;
    }

    const radioGroups = new Set();
    form
      .querySelectorAll(".quick-view-content-product-options input[type='radio']")
      .forEach((radio) => radioGroups.add(radio.name));

    for (const name of radioGroups) {
      if (!form.querySelector(`input[name="${CSS.escape(name)}"]:checked`)) return false;
    }

    return true;
  }

  syncQuickViewVariant(root, product) {
    const form = root.querySelector("form");
    if (!form) return;

    const idInput = form.querySelector('[name="id"]');
    const atcBtn = form.querySelector('button[name="add"]');
    const priceEls = root.querySelectorAll("[data-price]");
    const compareEl = root.querySelector("[data-compare-price]");
    const priceWrap = root.querySelector(".price");

    const selectedOptions = this.getSelectedOptions(form);
    if (!selectedOptions.length) return;

    const variant =
      product.variants.find((v) => JSON.stringify(v.options) === JSON.stringify(selectedOptions)) ||
      null;

    if (!variant) {
      if (atcBtn) {
        atcBtn.disabled = true;
        const allSelected = this.allQuickViewOptionsSelected(form);
        atcBtn.textContent = allSelected
          ? atcBtn.dataset.textUnavailable || this.dataset.textUnavailable
          : atcBtn.dataset.textChoose || atcBtn.dataset.textUnavailable || this.dataset.textUnavailable;
      }
      return;
    }

    if (idInput) idInput.value = variant.id;

    priceEls.forEach((el) => {
      el.textContent = window.Shopify.formatMoney(variant.price);
    });
    if (compareEl && variant.compare_at_price != null) {
      compareEl.textContent = window.Shopify.formatMoney(variant.compare_at_price);
    }
    if (priceWrap) {
      priceWrap.setAttribute(
        "data-has-price-compare",
        variant.compare_at_price > variant.price ? "true" : "false",
      );
      priceWrap.setAttribute("data-price-varies", "false");
    }

    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available
        ? atcBtn.dataset.textAdd || this.dataset.textAddToCart
        : atcBtn.dataset.textSoldOut || this.dataset.textSoldOut;
    }

    const colorSwatchesSelectedValue = form.querySelector(".color-swatches-selected-value");
    if (colorSwatchesSelectedValue) {
      colorSwatchesSelectedValue.textContent =
        form.querySelector(".color-swatches input:checked")?.value || colorSwatchesSelectedValue.textContent;
    }

    // Preferred path: this product exposes per-variant media (custom.media
    // metafield). Rebuild the gallery with that variant's images + shared media.
    if (this.hasVariantMedia()) {
      const left = root.querySelector(".quick-view-content-left");
      if (left) {
        left.innerHTML = this.buildSlideshowMarkup(this.imagesForVariant(variant), product.title);
      }
      return;
    }

    if (variant.featured_image && variant.featured_image.src) {
      const featuredSrc = variant.featured_image.src.split("?")[0];
      const slideIndex = product.images.findIndex((img) => {
        const src = typeof img === "string" ? img : (img && img.src) || "";
        return src.split("?")[0] === featuredSrc;
      });
      const slideshow = root.querySelector("slideshow-component");
      if (slideshow && slideIndex >= 0) {
        if (typeof slideshow.go === "function") {
          slideshow.go(slideIndex);
        } else {
          const track = slideshow.querySelector(".slideshow-track");
          const slides = slideshow.querySelectorAll(".slideshow-slide");
          if (track && slides.length) {
            track.style.transform = `translateX(-${slideIndex * 100}%)`;
            const pagination = slideshow.querySelector(".slideshow-pagination span");
            if (pagination) pagination.textContent = `${slideIndex + 1} / ${slides.length}`;
          }
        }
      }
    }
  }

  clearQuickView() {
    this.productData = null;
    this.productUrl = null;
    this.optionsNode = null;
    this.variantMedia = {};
    this.commonMedia = [];
    this.isCompact = false;
    this._latestLoadUrl = null;
    this.dialog?.classList.remove("is-compact");
    const content = this.querySelector(".quick-view-content");
    if (content) {
      content.querySelector(".quick-view-content-product-options")?.removeAttribute("data-qv-options-bound");
      content.innerHTML = "";
    }
  }
}
customElements.define("quick-view-modal", QuickViewModal);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.slides = this.querySelectorAll(".slideshow-slide");
    this.currentIndex = 0;
    this.interval = null;
    this.lcpReady = false;

    this.handleSlidesAccessibility();
    this.animateOnScroll();
    this.handleFullHeight();
    this.handleEditor();

    if (this.dataset.lcpDefer === "true") {
      this.initLcpDefer();
      return;
    }

    this.initInteractive();
  }

  initInteractive() {
    this.handleControls();
    this.handleAutoplay();
    this.handleTouch();
    this.handleKeyboard();
  }

  initLcpDefer() {
    this.handleControls();
    this.scheduleLcpActivate();
  }

  scheduleLcpActivate() {
    const firstSlide = this.slides[0];
    const firstMedia = firstSlide
      ? firstSlide.querySelector("img[src], video")
      : null;
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;
      this.activateLcp();
    };

    const fallbackId = setTimeout(finish, 2000);

    if (!firstMedia) {
      clearTimeout(fallbackId);
      finish();
      return;
    }

    if (firstMedia.tagName === "IMG") {
      if (firstMedia.complete && firstMedia.naturalWidth > 0) {
        clearTimeout(fallbackId);
        if (typeof firstMedia.decode === "function") {
          firstMedia.decode().catch(() => {}).finally(finish);
        } else {
          finish();
        }
        return;
      }

      firstMedia.addEventListener(
        "load",
        () => {
          clearTimeout(fallbackId);
          if (typeof firstMedia.decode === "function") {
            firstMedia.decode().catch(() => {}).finally(finish);
          } else {
            finish();
          }
        },
        { once: true },
      );
      firstMedia.addEventListener(
        "error",
        () => {
          clearTimeout(fallbackId);
          finish();
        },
        { once: true },
      );
      return;
    }

    clearTimeout(fallbackId);
    finish();
  }

  activateLcp() {
    if (this.dataset.lcpDefer !== "true" || this.lcpReady) return;
    this.lcpReady = true;
    this.hydrateDeferredMedia();
    this.dataset.lcpReady = "true";
    this.handleAutoplay();
    this.handleTouch();
    this.handleKeyboard();
  }

  hydrateDeferredMedia() {
    this.querySelectorAll("source[data-srcset]").forEach((source) => {
      source.setAttribute("srcset", source.dataset.srcset);
      source.removeAttribute("data-srcset");
    });

    this.querySelectorAll("img[data-src]").forEach((img) => {
      img.setAttribute("src", img.dataset.src);
      img.removeAttribute("data-src");
    });

    this.querySelectorAll(".slideshow-slide .video-wrapper[data-video-autoplay='false']").forEach((wrapper) => {
      wrapper.dataset.videoAutoplay = "true";
    });
  }

  prev() {
    this.activateLcp();
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.update();
  }

  next() {
    this.activateLcp();
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.update();
  }

  go(index) {
    this.activateLcp();
    this.currentIndex = index;
    this.update();
  }

  update() {
    const offset = -this.currentIndex * 100;
    this.querySelector(".slideshow-track").style.transform = `translateX(${offset}%)`;

    this.slides.forEach((slide, index) => {
      slide.classList.toggle("active", index === this.currentIndex);
    });

    this.querySelectorAll(".slideshow-pagination[data-pagination-type='dots'] button").forEach((btn, i) => {
      btn.classList.toggle("active", i === this.currentIndex);
    });

    this.querySelectorAll(".slideshow-pagination[data-pagination-type='fraction'] span").forEach((elem) => {
      elem.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
    });

    this.handleSlidesAccessibility();
  }

  handleControls() {
    this.querySelectorAll(".slideshow-control").forEach((btn) => {
      if (this.slides.length <= 1) {
        btn.disabled = true;
      }

      btn.addEventListener("click", () => {
        if (btn.name === "previous") {
          this.prev();
        } else if (btn.name === "next") {
          this.next();
        }
      });
    });

    this.querySelectorAll(".slideshow-pagination button").forEach((btn, index) => {
      btn.addEventListener("click", () => {
        this.go(index);
      });
    });
  }

  handleAutoplay() {
    if (!this.dataset.autoplay || this.dataset.autoplay === "0") return;

    const start = () => {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = setInterval(() => this.next(), Number(this.dataset.autoplay) * 1000);
      this.dataset.autoplayStopped = "false";
      this.querySelector(".slideshow-track").setAttribute("aria-live", "off");
    };

    const stop = () => {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
      this.dataset.autoplayStopped = "true";
      this.querySelector(".slideshow-track").setAttribute("aria-live", "polite");
    };

    // Exposed so disconnectedCallback can halt the timer when removed.
    this.stopAutoplay = stop;
    start();

    // Listeners are on the element itself, so they're GC'd with it — only the
    // interval needs explicit teardown.
    this.addEventListener("focusin", stop);
    this.addEventListener("focusout", start);
    this.addEventListener("mouseenter", stop);
    this.addEventListener("mouseleave", start);
    this.addEventListener("touchstart", stop, { passive: true });
    this.addEventListener("touchend", start);

    this.addEventListener("shopify:block:select", (e) => {
      if (e.target.closest(`[data-section-id="${this.dataset.sectionId}"]`)) stop();
    });
  }

  handleKeyboard() {
    this.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") this.prev();
      else if (event.key === "ArrowRight") this.next();
    });
  }

  handleTouch() {
    let startX = 0;
    let endX = 0;

    this.addEventListener("touchstart", (e) => {
      if (e.touches.length > 1) return;
      startX = e.touches[0].clientX;
    });

    this.addEventListener("touchend", (e) => {
      if (!startX || e.changedTouches.length > 1) return;
      endX = e.changedTouches[0].clientX;
      const swipeDistance = startX - endX;

      if (swipeDistance > 10) {
        this.next();
      } else if (swipeDistance < -10) {
        this.prev();
      }
    });
  }

  handleSlidesAccessibility() {
    this.slides.forEach((slide, i) => {
      if (i === this.currentIndex) {
        slide.removeAttribute("aria-hidden");
        slide.removeAttribute("tabindex");
        slide.querySelectorAll("a, button").forEach((el) => {
          el.removeAttribute("tabindex");
        });
      } else {
        slide.setAttribute("aria-hidden", "true");
        slide.setAttribute("tabindex", "-1");
        slide.querySelectorAll("a, button").forEach((el) => {
          el.setAttribute("tabindex", "-1");
        });
      }
    });
  }

  animateOnScroll() {
    const slides = this.querySelectorAll(".slideshow-slide");
    if (!slides.length || slides[0].dataset.overlayOpacity === undefined) return;
  
    let ticking = false;
  
    const updateOverlay = () => {
      if (this.clientHeight > window.innerHeight) return;

      const top = Math.round(this.getBoundingClientRect().top);
      const bottom = Math.round(this.getBoundingClientRect().bottom);
      const visibilityTop = Math.round(((window.innerHeight - top) / this.clientHeight) * 100);
      const visibilityBottom = Math.round((bottom / this.clientHeight) * 100);
  
      if ((visibilityTop > 0 && visibilityTop < 100) || (visibilityBottom > 0 && visibilityBottom < 100)) {
        slides.forEach((elem) => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity);
          const visibility = visibilityTop > 0 && visibilityTop < 100 ? visibilityTop : visibilityBottom;
          const final = Math.round((100 - overlayOpacity) * (1 - visibility / 100) + overlayOpacity);
          elem.style.setProperty("--overlay-opacity", final + "%");
        });
      }
  
      ticking = false;
    };
  
    // Stored so it can be removed on disconnect (otherwise every slideshow —
    // including the ones quick-view rebuilds per variant — leaks a permanent
    // window scroll listener).
    this.onOverlayScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateOverlay);
        ticking = true;
      }
    };
    window.addEventListener("scroll", this.onOverlayScroll, { passive: true });
  }

  handleFullHeight() {
    const indicator = this.querySelector(".slideshow-full-height-indicator");
    if (!indicator) return;

    let fullHeightTicking = false;
    this.onFullHeightScroll = () => {
      if (fullHeightTicking) return;
      fullHeightTicking = true;
      requestAnimationFrame(() => {
        if (window.scrollY > 10) {
          indicator.classList.add("hide");
        } else {
          indicator.classList.remove("hide");
        }
        fullHeightTicking = false;
      });
    };
    window.addEventListener("scroll", this.onFullHeightScroll, { passive: true });
  }

  handleEditor() {
    // Only needed in the theme editor — skip the global listener on storefront.
    if (!(window.Shopify && window.Shopify.designMode)) return;

    this.onBlockSelect = (event) => {
      if (event.target.closest(`[data-section-id="${this.dataset.sectionId}"]`)) {
        this.go(Number(event.target.dataset.index));
      }
    };
    document.addEventListener("shopify:block:select", this.onBlockSelect);
  }

  disconnectedCallback() {
    clearInterval(this.autoplayInterval);
    if (this.onOverlayScroll) window.removeEventListener("scroll", this.onOverlayScroll);
    if (this.onFullHeightScroll) window.removeEventListener("scroll", this.onFullHeightScroll);
    if (this.onBlockSelect) document.removeEventListener("shopify:block:select", this.onBlockSelect);
  }
}
customElements.define("slideshow-component", SlideshowComponent);

class CarouselComponent extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector(".carousel-track");
    this.handleControls();
    this.handleControlsPosition();
    this.handlePagination();
  }

  handleControls() {
    const controls = this.querySelectorAll(".carousel-control");
    if (!controls.length) return;

    this.onControlClick = (event) => {
      const btn = event.currentTarget;
      const firstSlideOffset = this.querySelector(".carousel-slide:nth-child(1)")?.getBoundingClientRect().left;
      const secondSlideOffset = this.querySelector(".carousel-slide:nth-child(2)")?.getBoundingClientRect().left;
      const slideWidth = secondSlideOffset - firstSlideOffset;

      if (btn.name === "previous") {
        if (this.track.scrollLeft <= 16) {
          this.track.scrollTo({ left: this.track.scrollWidth, behavior: "smooth" });
        } else {
          this.track.scrollBy({ left: -slideWidth, behavior: "smooth" });
        }
      } else {
        if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 16) {
          this.track.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          this.track.scrollBy({ left: slideWidth, behavior: "smooth" });
        }
      }
    };

    // One shared state updater for all controls, and one set of window
    // listeners for the whole component (was one set per button before).
    this.updateControlsState = () => {
      const disabled =
        this.track.querySelectorAll(".carousel-slide").length <= 1 ||
        this.track.scrollWidth <= this.track.clientWidth;
      controls.forEach((btn) => {
        btn.disabled = disabled;
      });
    };

    controls.forEach((btn) => btn.addEventListener("click", this.onControlClick));

    this.controlsTimeout = setTimeout(this.updateControlsState, 1000);
    window.addEventListener("dialog:open", this.updateControlsState);
    window.addEventListener("resize", this.updateControlsState);
  }

  async handleControlsPosition() {
    if (this.dataset.controlsAdaptToImage !== "true") return;

    await new Promise((resolve) => setTimeout(resolve, 400));
    if (!this.isConnected) return;

    const update = () => {
      const image = this.querySelector(".carousel-slide img") || this.querySelector(".carousel-slide .placeholder-svg");
      if (!image) return;
      const offset = image.clientHeight / 2;
      this.querySelectorAll(".carousel-control").forEach((btn) => {
        btn.style.top = `${offset}px`;
      });
    };
    update();

    this.onControlsPositionResize = this.throttle(update, 150);
    window.addEventListener("resize", this.onControlsPositionResize);
  }

  handlePagination() {
    const paginationCounter = this.querySelector(".carousel-pagination-counter");
    const paginationLine = this.querySelector(".carousel-pagination-line");
    if (!paginationCounter && !paginationLine) return;

    const totalSlides = this.querySelectorAll(".carousel-slide").length;

    const update = () => {
      if (!this.querySelector(".carousel-slide")) return

      const visibleSlides = Math.floor(this.track.clientWidth / this.querySelector(".carousel-slide").clientWidth);
      let firstVisibleSlide = Math.round(this.track.scrollLeft / this.querySelector(".carousel-slide").clientWidth) + visibleSlides;

      if (firstVisibleSlide > totalSlides) {
        firstVisibleSlide = totalSlides;
      }

      if (paginationCounter) {
        paginationCounter.querySelector("span").innerHTML = `${firstVisibleSlide}/${totalSlides}`;
      }
      if (paginationLine) {
        paginationLine.style.setProperty("--progress", `${(firstVisibleSlide / totalSlides) * 100}%`);
      }
    };

    this.paginationTimeout = setTimeout(update, 1000);

    // A single throttled handler (the previous code called update() twice per
    // scroll event and discarded the throttle/debounce wrappers entirely).
    this.onTrackScroll = this.throttle(update, 150);
    this.track.addEventListener("scroll", this.onTrackScroll, { passive: true });

    this.onPaginationResize = this.throttle(update, 150);
    window.addEventListener("resize", this.onPaginationResize);

    this.onPaginationDialogOpen = () => update();
    window.addEventListener("dialog:open", this.onPaginationDialogOpen);
  }

  disconnectedCallback() {
    clearTimeout(this.controlsTimeout);
    clearTimeout(this.paginationTimeout);

    if (this.updateControlsState) {
      window.removeEventListener("dialog:open", this.updateControlsState);
      window.removeEventListener("resize", this.updateControlsState);
    }
    if (this.onControlsPositionResize) {
      window.removeEventListener("resize", this.onControlsPositionResize);
    }
    if (this.onPaginationResize) {
      window.removeEventListener("resize", this.onPaginationResize);
    }
    if (this.onPaginationDialogOpen) {
      window.removeEventListener("dialog:open", this.onPaginationDialogOpen);
    }
  }

  throttle(func, limit) {
    let lastCall = 0;
    return function (...args) {
      const now = Date.now();
      if (now - lastCall >= limit) {
        lastCall = now;
        func.apply(this, args);
      }
    };
  }

  debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }
}
customElements.define("carousel-component", CarouselComponent);

class DialogComponent extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.closest("dialog");
    this.triggerElement = null;

    this.handleOpen();
    this.handleClose();
    this.handleObserver();
  }

  handleOpen() {
    this.onBodyOpenClick = (event) => {
      const button = event.target.closest("[data-open-dialog]");
      if (!button) return;

      event.preventDefault();
      const dialogId = button.dataset.openDialog;

      if (dialogId == this.dialog.id) {
        this.triggerElement = button;
        this.dialog.showModal();
      }
    };
    document.body.addEventListener("click", this.onBodyOpenClick);
  }

  handleClose() {
    const close = () => {
      this.dialog.classList.add("closing");
      this.dialog.addEventListener(
        "transitionend",
        () => {
          this.dialog.classList.remove("closing");
          this.dialog.close();
        },
        { once: true },
      );
    };

    this.onBodyCloseClick = (event) => {
      const button = event.target.closest("[data-dialog-close]");
      if (button && this.contains(button)) {
        close();
      }
    };
    document.body.addEventListener("click", this.onBodyCloseClick);

    this.onBackdropClick = (event) => {
      const path = event.composedPath();
      const inner = this.dialog.querySelector(".dialog-inner");

      if (!path.includes(inner)) {
        close();
      }
    };
    this.dialog.addEventListener("click", this.onBackdropClick);
  }

  handleObserver() {
    this.observer = new MutationObserver(() => {
      if (this.dialog.open) {
        document.body.style.overflow = "hidden";
        window.dispatchEvent(
          new CustomEvent("dialog:open", {
            detail: {
              dialog: this.dialog,
              triggerElement: this.triggerElement,
            },
          }),
        );
      } else {
        document.body.style.overflow = "";
        window.dispatchEvent(
          new CustomEvent("dialog:close", {
            detail: {
              dialog: this.dialog,
            },
          }),
        );
      }
    });

    this.observer.observe(this.dialog, {
      attributes: true,
      attributeFilter: ["open"],
    });
  }

  disconnectedCallback() {
    document.body.removeEventListener("click", this.onBodyOpenClick);
    document.body.removeEventListener("click", this.onBodyCloseClick);
    this.dialog?.removeEventListener("click", this.onBackdropClick);
    this.observer?.disconnect();
  }
}
customElements.define("dialog-component", DialogComponent);

class DropdownComponent extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector(".dropdown-btn");
    this.content = this.querySelector(".dropdown-content");

    this.button.addEventListener("click", (event) => {
      event.preventDefault();
      this.toggle();
    });

    this.handleAccessibility();
  }

  open() {
    this.button.setAttribute("aria-expanded", true);
    this.button.dispatchEvent(new CustomEvent("dropdown:open", { bubbles: true }));
    this.content.hidden = false;

    if (window.innerWidth - this.button.getBoundingClientRect().right < this.content.offsetWidth) {
      this.content.style.left = "auto";
      this.content.style.right = "0";
    } else {
      this.content.style.left = "";
      this.content.style.right = "";
    }
  }

  close() {
    if (this.button.getAttribute("aria-expanded") === "false") return;
    this.button.setAttribute("aria-expanded", false);
    this.button.dispatchEvent(new CustomEvent("dropdown:close", { bubbles: true }));
    this.content.hidden = true;
  }

  toggle() {
    const isExpanded = this.button.getAttribute("aria-expanded") === "true";
    isExpanded ? this.close() : this.open();
  }

  handleAccessibility() {
    this.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.close();
        this.button.focus();
      }
    });

    this.addEventListener("focusout", (event) => {
      if (event.relatedTarget && !this.contains(event.relatedTarget) && !event.relatedTarget.closest("dialog")) {
        this.close();
      }
    });

    // Global outside-click listener — stored so it's removed on disconnect.
    this.onDocumentClick = (event) => {
      if (!this.contains(event.target) && !event.target.closest("dialog")) {
        this.close();
      }
    };
    document.addEventListener("click", this.onDocumentClick);
  }

  disconnectedCallback() {
    if (this.onDocumentClick) document.removeEventListener("click", this.onDocumentClick);
  }
}
customElements.define("dropdown-component", DropdownComponent);

class CollapseComponent extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector(".collapse-content");

    this.onSummaryClick = this.toggle.bind(this);
    this.onResize = this.fixHeight.bind(this);
    this.onDialogOpen = this.handleDialogOpen.bind(this);

    this.handleNestedChange = this.handleNestedChange.bind(this);
    this.handleInnerTransitionEnd = this.handleInnerTransitionEnd.bind(this);

    this.summary?.addEventListener("click", this.onSummaryClick);
    window.addEventListener("resize", this.onResize);
    window.addEventListener("dialog:open", this.onDialogOpen);

    this.addEventListener("collapse:open", this.handleNestedChange);
    this.addEventListener("collapse:close", this.handleNestedChange);
    this.content?.addEventListener("transitionend", this.handleInnerTransitionEnd);

    this.observer = new MutationObserver(() => {
      this.fixHeight();
    });

    if (this.content) {
      this.observer.observe(this.content, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    this.fixHeight();
  }

  handleDialogOpen() {
    if (this.closest(".dialog") && this.details?.hasAttribute("open") && this.content) {
      this.content.style.height = `${this.content.scrollHeight}px`;
    }
  }

  open() {
    if (!this.details || !this.content) return;
    this.details.open = true;
    this.content.style.height = `${this.content.scrollHeight}px`;
    this.dispatchEvent(new CustomEvent("collapse:open", { bubbles: true }));
  }

  close() {
    if (!this.details || !this.content) return;
    this.content.style.height = "0px";

    this.content.addEventListener(
      "transitionend",
      () => {
        this.content.style.height = "";
        this.details.removeAttribute("open");
      },
      { once: true },
    );

    this.dispatchEvent(new CustomEvent("collapse:close", { bubbles: true }));
  }

  toggle(event) {
    event.preventDefault();
    const isOpen = this.details?.hasAttribute("open");
    isOpen ? this.close() : this.open();
  }

  fixHeight() {
    if (!this.details || !this.content) return;

    if (this.details.hasAttribute("open")) {
      this.content.style.height = "auto";
      setTimeout(() => {
        if (this.content.scrollHeight > 0) {
          this.content.style.height = `${this.content.scrollHeight}px`;
        }
      }, 100);
    }
  }

  handleNestedChange(event) {
    if (event.target === this) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.fixHeight());
    });
  }

  handleInnerTransitionEnd(event) {
    if (event.target !== this.content) return;
    this.fixHeight();
  }

  disconnectedCallback() {
    this.summary?.removeEventListener("click", this.onSummaryClick);
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("dialog:open", this.onDialogOpen);

    this.removeEventListener("collapse:open", this.handleNestedChange);
    this.removeEventListener("collapse:close", this.handleNestedChange);
    this.content?.removeEventListener("transitionend", this.handleInnerTransitionEnd);

    this.observer?.disconnect();
  }
}

customElements.define("collapse-component", CollapseComponent);

class CountdownComponent extends HTMLElement {
  constructor() {
    super();

    const countdown = Number(this.dataset.countdown);

    if (isNaN(countdown)) {
      return;
    }

    this.myInterval = setInterval(() => {
      const now = new Date().getTime();
      const diff = countdown - now;
      this.update(diff);
    }, 1000);
  }

  update(diff) {
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const daysElem = this.querySelector("[data-countdown-days]");
    const hoursElem = this.querySelector("[data-countdown-hours]");
    const minutesElem = this.querySelector("[data-countdown-minutes]");
    const secondsElem = this.querySelector("[data-countdown-seconds]");

    if (days > 0) {
      daysElem.textContent = days;
    } else {
      daysElem?.parentElement.remove();
    }

    if (hours > 0) {
      hoursElem.textContent = hours;
    } else {
      hoursElem?.parentElement.remove();
    }

    minutesElem.textContent = minutes;
    secondsElem.textContent = seconds;
    
    if (diff < 0) {
      clearInterval(this.myInterval);
      this.closest('[data-has-countdown]')?.setAttribute("data-has-countdown", "false");
      this.remove();
    }
  }

  disconnectedCallback() {
    clearInterval(this.myInterval);
  }
}
customElements.define("countdown-component", CountdownComponent);

class ShareComponent extends HTMLElement {
  constructor() {
    super();

    this.shareButton = this.querySelector(".btn-share");
    this.dropdownComponent = this.querySelector("dropdown-component");
    this.url = this.dataset.url || window.location.href;
    this.title = this.dataset.title || document.title;

    if (navigator.share) {
      this.shareButton.addEventListener("click", () => {
        navigator.share({
          title: this.title,
          url: this.url,
        });
      });
    } else {
      setTimeout(() => {
        this.shareButton.remove();
        this.dropdownComponent.hidden = false;

        const innerButton = this.dropdownComponent.querySelector(".dropdown-content .button");
        innerButton.addEventListener("click", () => {
          navigator.clipboard.writeText(this.url).then(() => {
            innerButton.textContent = innerButton.dataset.textCopied;
          });
        });
      }, 500);
    }
  }
}
customElements.define("share-component", ShareComponent);


class HeroBanner extends HTMLElement {
  constructor() {
    super();

    this.EFFECTS = new Set(["fade", "slide", "zoom", "reveal"]);
    this.SPEEDS = new Set(["fast", "normal", "slow"]);
    this.SPEED_MAP = {
      fast: { fade: 220, slide: 260, zoom: 300, reveal: 240 },
      normal: { fade: 320, slide: 360, zoom: 420, reveal: 320 },
      slow: { fade: 420, slide: 480, zoom: 560, reveal: 420 },
    };

    this.onNextClick = this.goNext.bind(this);
    this.onPrevClick = this.goPrev.bind(this);
    this.onTouchStart = this.handleTouchStart.bind(this);
    this.onTouchMove = this.handleTouchMove.bind(this);
    this.onTouchEnd = this.handleTouchEnd.bind(this);

    this.startX = 0;
    this.startY = 0;
    this.deltaX = 0;
    this.isSwiping = false;
    this.lastSwipeAt = 0;
    this.SWIPE_THRESHOLD = 40;
    this.SWIPE_COOLDOWN = 250;
  }

  connectedCallback() {
    if (this.dataset.sliderInit === "true") return;
    this.dataset.sliderInit = "true";

    this.slideWrapper = this.querySelector(".hero-banner__slide-wrapper");
    this.slideControls = this.querySelector(".hero-banner__slide-controls");
    this.prevButton = this.querySelector(".hero-banner__slide-controls-prev");
    this.nextButton = this.querySelector(".hero-banner__slide-controls-next");
    this.dotsWrap = this.querySelector(".hero-banner__dots");
    this.dots = Array.from(this.querySelectorAll(".hero-banner__dot"));

    if (!this.slideWrapper || !this.slideControls || !this.prevButton || !this.nextButton) return;

    this.slides = Array.from(this.slideWrapper.children);
    this.slides.forEach((slide, index) => {
      slide.dataset.slideIndex = String(index);
    });

    if (this.slides.length < 2) {
      this.slideControls.classList.remove("show");
      if (this.dotsWrap) this.dotsWrap.style.display = "none";
      return;
    }

    this.slideControls.classList.add("show");
    this.applySpeedVars();

    this.nextButton.addEventListener("click", this.onNextClick);
    this.prevButton.addEventListener("click", this.onPrevClick);

    this.dotHandlers = [];
    this.dots.forEach((dot) => {
      const handler = () => {
        const targetIndex = Number(dot.dataset.dotIndex);
        this.goToIndex(targetIndex);
      };
      this.dotHandlers.push({ dot, handler });
      dot.addEventListener("click", handler);
    });

    this.slideWrapper.addEventListener("touchstart", this.onTouchStart, { passive: true });
    this.slideWrapper.addEventListener("touchmove", this.onTouchMove, { passive: true });
    this.slideWrapper.addEventListener("touchend", this.onTouchEnd, { passive: true });

    this.updateDots();
  }

  disconnectedCallback() {
    this.nextButton?.removeEventListener("click", this.onNextClick);
    this.prevButton?.removeEventListener("click", this.onPrevClick);

    this.dotHandlers?.forEach(({ dot, handler }) => dot.removeEventListener("click", handler));

    this.slideWrapper?.removeEventListener("touchstart", this.onTouchStart);
    this.slideWrapper?.removeEventListener("touchmove", this.onTouchMove);
    this.slideWrapper?.removeEventListener("touchend", this.onTouchEnd);
  }

  getEffect() {
    const v = this.dataset.animationEffect;
    return this.EFFECTS.has(v) ? v : "fade";
  }

  getSpeed() {
    const v = this.dataset.animationSpeed;
    return this.SPEEDS.has(v) ? v : "normal";
  }

  applySpeedVars() {
    const cfg = this.SPEED_MAP[this.getSpeed()];
    this.style.setProperty("--hero-fade-ms", `${cfg.fade}ms`);
    this.style.setProperty("--hero-slide-ms", `${cfg.slide}ms`);
    this.style.setProperty("--hero-zoom-ms", `${cfg.zoom}ms`);
    this.style.setProperty("--hero-reveal-ms", `${cfg.reveal}ms`);
  }

  resetAnimationClasses(el) {
    el.classList.remove("anim-fade", "anim-slide-next", "anim-slide-prev", "anim-zoom", "anim-reveal");
  }

  animateCurrentSlide(direction) {
    const currentSlide = this.slideWrapper.firstElementChild;
    if (!currentSlide) return;

    this.applySpeedVars();
    const effect = this.getEffect();

    this.resetAnimationClasses(currentSlide);
    currentSlide.offsetHeight;

    if (effect === "fade") currentSlide.classList.add("anim-fade");
    else if (effect === "slide") currentSlide.classList.add(direction === "prev" ? "anim-slide-prev" : "anim-slide-next");
    else if (effect === "zoom") currentSlide.classList.add("anim-zoom");
    else if (effect === "reveal") currentSlide.classList.add("anim-reveal");

    currentSlide.addEventListener("animationend", () => this.resetAnimationClasses(currentSlide), { once: true });
  }

  updateDots() {
    if (!this.dots.length) return;

    const currentSlide = this.slideWrapper.firstElementChild;
    const activeIndex = Number(currentSlide?.dataset.slideIndex || 0);

    this.dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle("is-active", isActive);
      dot.setAttribute("aria-current", isActive ? "true" : "false");
    });
  }

  goNext() {
    this.slideWrapper.appendChild(this.slideWrapper.firstElementChild);
    this.animateCurrentSlide("next");
    this.updateDots();
  }

  goPrev() {
    this.slideWrapper.prepend(this.slideWrapper.lastElementChild);
    this.animateCurrentSlide("prev");
    this.updateDots();
  }

  goToIndex(targetIndex) {
    let guard = 0;
    while (guard < this.slides.length) {
      const currentIndex = Number(this.slideWrapper.firstElementChild?.dataset.slideIndex || 0);
      if (currentIndex === targetIndex) break;
      this.slideWrapper.appendChild(this.slideWrapper.firstElementChild);
      guard += 1;
    }
    this.animateCurrentSlide("next");
    this.updateDots();
  }

  handleTouchStart(e) {
    const touch = e.changedTouches[0];
    this.startX = touch.clientX;
    this.startY = touch.clientY;
    this.deltaX = 0;
    this.isSwiping = false;
  }

  handleTouchMove(e) {
    const touch = e.changedTouches[0];
    const dx = touch.clientX - this.startX;
    const dy = touch.clientY - this.startY;

    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
      this.isSwiping = true;
      this.deltaX = dx;
    }
  }

  handleTouchEnd() {
    if (!this.isSwiping) return;

    const now = Date.now();
    if (now - this.lastSwipeAt < this.SWIPE_COOLDOWN) return;

    if (Math.abs(this.deltaX) >= this.SWIPE_THRESHOLD) {
      if (this.deltaX < 0) this.goNext();
      else this.goPrev();
      this.lastSwipeAt = now;
    }
  }
}

if (!customElements.get("hero-banner")) {
  customElements.define("hero-banner", HeroBanner);
}


class CollectionTabs extends HTMLElement {
  constructor() {
    super();

    this.onTabClick = this.onTabClick.bind(this);
    this.onTabKeydown = this.onTabKeydown.bind(this);
    this.onBlockSelect = this.onBlockSelect.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === "true") return;
    this.dataset.initialized = "true";

    this.tabs = Array.from(this.querySelectorAll("[data-tab-trigger]"));
    this.panels = Array.from(this.querySelectorAll("[data-tab-panel]"));
    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick);
      tab.addEventListener("keydown", this.onTabKeydown);
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:block:select", this.onBlockSelect);
    }
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => {
      tab.removeEventListener("click", this.onTabClick);
      tab.removeEventListener("keydown", this.onTabKeydown);
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }
  }

  onTabClick(event) {
    const tab = event.currentTarget;
    const id = tab.dataset.tabTrigger;
    this.activateTab(id, true);
  }

  onTabKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    if (currentIndex < 0) return;

    let nextIndex = null;

    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = this.tabs.length - 1;

    if (nextIndex === null) return;

    event.preventDefault();
    const nextTab = this.tabs[nextIndex];
    this.activateTab(nextTab.dataset.tabTrigger, true);
  }

  onBlockSelect(event) {
    const blockEl = event.target;
    if (!blockEl || !this.contains(blockEl)) return;

    const tabTrigger = blockEl.dataset.tabTrigger || blockEl.dataset.tabPanel || blockEl.dataset.blockId;
    if (!tabTrigger) return;

    this.activateTab(tabTrigger, false);
  }

  activateTab(id, focusTab = false) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.tabTrigger === id;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
      tab.setAttribute("tabindex", active ? "0" : "-1");
      if (active && focusTab) tab.focus();
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.tabPanel === id;
      if (active) this.hydratePanel(panel);
      panel.classList.toggle("is-active", active);
      panel.hidden = !active;
    });

    // Recalculate carousel controls/pagination after panel swap.
    window.dispatchEvent(new Event("resize"));
  }

  // Inactive tabs render their carousel inside an inert <template> so ~120
  // off-screen product cards don't upgrade on initial load. Materialize the
  // markup (which upgrades the custom elements) the first time a tab is shown.
  hydratePanel(panel) {
    const template = panel.querySelector("template[data-tab-content]");
    if (!template) return;

    panel.insertBefore(template.content.cloneNode(true), template);
    template.remove();
  }
}
customElements.define("collection-tabs", CollectionTabs);


class BundleBox extends HTMLElement {
  constructor() {
    super();

    this.selectedItems = new Map();
    this.selectedCount = 0;
    this.limit = 0;

    this.onSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === "true") return;
    this.dataset.initialized = "true";

    this.section = this.closest(".bundle-box");
    if (!this.section) return;

    this.statusLabel = this.section.dataset.statusLabel || "products selected";

    this.items = Array.from(this.querySelectorAll(".bundle-box__item"));
    this.variantButtons = Array.from(this.querySelectorAll(".bundle-box__variant"));
    this.pickedList = this.querySelector(".bundle-box__picked-list");
    this.emptyState = this.querySelector(".bundle-box__empty");
    this.statusEl = this.querySelector(".bundle-box__status");
    this.form = this.querySelector(".bundle-box__form");
    this.variantInput = this.querySelector("[data-bundle-variant-input]");
    this.productsPropertyInput = this.querySelector("[data-bundle-products-property]");
    this.submitButton = this.querySelector(".bundle-box__submit-btn");

    this.bindVariantSwitch();
    this.bindProductCards();
    this.bindSubmit();

    const activeVariant =
      this.variantButtons.find((btn) => btn.classList.contains("is-active")) || this.variantButtons[0];
    if (activeVariant) this.activateVariant(activeVariant);

    this.updateUI();
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener("submit", this.onSubmit);
  }

  bindVariantSwitch() {
    this.variantButtons.forEach((btn) => {
      btn.addEventListener("click", () => this.activateVariant(btn));
    });
  }

  activateVariant(btn) {
    this.variantButtons.forEach((b) => b.classList.remove("is-active"));
    btn.classList.add("is-active");

    const nextLimit = Number(btn.dataset.limit || 0);
    this.limit = Number.isFinite(nextLimit) ? nextLimit : 0;

    if (this.variantInput) this.variantInput.value = btn.dataset.variantId || "";

    this.resetSelections();
  }

  resetSelections() {
    this.selectedItems.clear();
    this.selectedCount = 0;

    this.items.forEach((item) => {
      item.classList.remove("is-active");

      const qtyWrap = item.querySelector(".bundle-box__qty");
      const qtyValue = item.querySelector(".bundle-box__qty-value");
      const addBtn = item.querySelector(".bundle-box__add-btn");
      const plusBtn = item.querySelector('[data-action="plus"]');

      if (qtyWrap) qtyWrap.hidden = true;
      if (qtyValue) qtyValue.textContent = "1";
      if (addBtn && !addBtn.classList.contains("out-of-stock")) addBtn.disabled = false;
      if (plusBtn) plusBtn.disabled = false;

      // Sync dataset with currently selected native variant/title
      this.syncSelectedItemIdentity(item);
    });

    this.renderPickedList();
    this.updateUI();
  }

  bindProductCards() {
    this.items.forEach((item) => {
      const addBtn = item.querySelector(".bundle-box__add-btn");
      const qtyWrap = item.querySelector(".bundle-box__qty");
      const qtyValue = item.querySelector(".bundle-box__qty-value");
      const minusBtn = item.querySelector('[data-action="minus"]');
      const plusBtn = item.querySelector('[data-action="plus"]');

      // Keep item identity synced when native product-card selectors change
      item.querySelectorAll(".product-card-form select").forEach((select) => {
        select.addEventListener("change", () => {
          this.syncSelectedItemIdentity(item);
        });
      });

      if (addBtn) {
        addBtn.addEventListener("click", () => {
          if (addBtn.disabled || this.selectedCount >= this.limit) return;

          this.syncSelectedItemIdentity(item);

          item.classList.add("is-active");
          if (qtyWrap) qtyWrap.hidden = false;

          const id = item.dataset.itemId;
          const title = item.dataset.itemTitle || "Product";
          const imageSrc = item.dataset.imageSrc || "";
          const imageAlt = item.dataset.imageAlt || "";

          const existing = this.selectedItems.get(id);
          if (existing) {
            existing.qty += 1;
            existing.title = title;
            existing.imageSrc = imageSrc;
            existing.imageAlt = imageAlt;
          } else {
            this.selectedItems.set(id, { title, imageSrc, imageAlt, qty: 1 });
          }

          this.selectedCount += 1;
          if (qtyValue) qtyValue.textContent = String(this.selectedItems.get(id).qty);

          this.renderPickedList();
          this.updateUI();
        });
      }

      if (minusBtn) {
        minusBtn.addEventListener("click", () => {
          this.syncSelectedItemIdentity(item);

          const id = item.dataset.itemId;
          const existing = this.selectedItems.get(id);
          if (!existing) return;

          existing.qty -= 1;
          this.selectedCount = Math.max(0, this.selectedCount - 1);

          if (existing.qty <= 0) {
            this.selectedItems.delete(id);
            item.classList.remove("is-active");
            if (qtyWrap) qtyWrap.hidden = true;
            if (qtyValue) qtyValue.textContent = "1";
          } else if (qtyValue) {
            qtyValue.textContent = String(existing.qty);
          }

          this.renderPickedList();
          this.updateUI();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener("click", () => {
          if (this.selectedCount >= this.limit) return;

          this.syncSelectedItemIdentity(item);

          const id = item.dataset.itemId;
          const existing = this.selectedItems.get(id);
          if (!existing) return;

          existing.qty += 1;
          this.selectedCount += 1;
          if (qtyValue) qtyValue.textContent = String(existing.qty);

          this.renderPickedList();
          this.updateUI();
        });
      }
    });
  }

  getItemVariantId(item) {
    const formIdInput = item.querySelector('.product-card-form form [name="id"]');
    if (formIdInput && formIdInput.value) return formIdInput.value;

    const variantSelect = item.querySelector('.product-card-form select[name="id"]');
    if (variantSelect && variantSelect.value) return variantSelect.value;

    return item.dataset.itemId || "";
  }

  getItemTitle(item) {
    const titleNode = item.querySelector(".product-card-link span");
    if (titleNode && titleNode.textContent.trim().length) {
      return titleNode.textContent.trim();
    }
    return item.dataset.itemTitle || "Product";
  }

  getItemImageData(item) {
    const image = item.querySelector(".product-card .img-wrapper img");
    return {
      src: image?.getAttribute("src") || item.dataset.imageSrc || "",
      alt: image?.getAttribute("alt") || item.dataset.imageAlt || ""
    };
  }

  syncSelectedItemIdentity(item) {
    const oldId = item.dataset.itemId || "";
    const newId = this.getItemVariantId(item);
    const newTitle = this.getItemTitle(item);
    const newImage = this.getItemImageData(item);

    if (!newId) return;

    item.dataset.itemId = newId;
    item.dataset.itemTitle = newTitle;
    item.dataset.imageSrc = newImage.src;
    item.dataset.imageAlt = newImage.alt;

    // If item already selected, move/update map entry to new variant id
    if (oldId && oldId !== newId && this.selectedItems.has(oldId)) {
      const existing = this.selectedItems.get(oldId);
      this.selectedItems.delete(oldId);
      this.selectedItems.set(newId, {
        title: newTitle,
        imageSrc: newImage.src,
        imageAlt: newImage.alt,
        qty: existing.qty
      });

      const qtyValue = item.querySelector(".bundle-box__qty-value");
      if (qtyValue) qtyValue.textContent = String(existing.qty);

      this.renderPickedList();
      this.updateUI();
      return;
    }

    if (this.selectedItems.has(newId)) {
      const current = this.selectedItems.get(newId);
      current.title = newTitle;
      current.imageSrc = newImage.src;
      current.imageAlt = newImage.alt;
      this.renderPickedList();
    }
  }

  renderPickedList() {
    if (!this.pickedList || !this.emptyState) return;

    this.pickedList.innerHTML = "";

    if (this.selectedItems.size === 0) {
      this.emptyState.hidden = false;
      return;
    }

    this.emptyState.hidden = true;

    for (const [id, item] of this.selectedItems.entries()) {
      const row = document.createElement("div");
      row.className = "bundle-box__picked-item";
      row.dataset.itemId = id;

      const left = document.createElement("div");
      left.className = "bundle-box__picked-left";

      if (item.imageSrc) {
        const img = document.createElement("img");
        img.className = "bundle-box__picked-image";
        img.src = item.imageSrc;
        img.alt = item.imageAlt || "";
        left.appendChild(img);
      }

      const title = document.createElement("p");
      title.className = "bundle-box__picked-title";
      title.textContent = item.title;
      left.appendChild(title);

      const right = document.createElement("div");
      right.className = "bundle-box__picked-right";

      const count = document.createElement("span");
      count.textContent = `x${item.qty}`;
      right.appendChild(count);

      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "bundle-box__picked-remove";
      remove.setAttribute("aria-label", "Remove");
      remove.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>`;
      remove.addEventListener("click", () => {
        this.removeItem(id);
      });

      right.appendChild(remove);
      row.appendChild(left);
      row.appendChild(right);

      this.pickedList.appendChild(row);
    }

    this.updateProductsProperty();
  }

  removeItem(id) {
    const existing = this.selectedItems.get(id);
    if (!existing) return;

    this.selectedCount = Math.max(0, this.selectedCount - existing.qty);
    this.selectedItems.delete(id);

    this.items.forEach((item) => {
      if (item.dataset.itemId !== id) return;

      item.classList.remove("is-active");
      const qtyWrap = item.querySelector(".bundle-box__qty");
      const qtyValue = item.querySelector(".bundle-box__qty-value");
      if (qtyWrap) qtyWrap.hidden = true;
      if (qtyValue) qtyValue.textContent = "1";
    });

    this.renderPickedList();
    this.updateUI();
  }

  updateProductsProperty() {
    if (!this.productsPropertyInput) return;

    const value = Array.from(this.selectedItems.values())
      .map((item) => `${item.title} (x${item.qty})`)
      .join(", ");

    this.productsPropertyInput.value = value;
  }

  updateUI() {
    if (this.statusEl) {
      this.statusEl.textContent = `${this.selectedCount}/${this.limit} ${this.statusLabel}`;
    }

    const canSubmit = this.limit > 0 && this.selectedCount === this.limit;
    if (this.submitButton) this.submitButton.disabled = !canSubmit;

    this.items.forEach((item) => {
      const addBtn = item.querySelector(".bundle-box__add-btn");
      const plusBtn = item.querySelector('[data-action="plus"]');
      const active = item.classList.contains("is-active");
      const hitLimit = this.selectedCount >= this.limit;

      if (addBtn && !active && !addBtn.classList.contains("out-of-stock")) {
        addBtn.disabled = hitLimit;
      }

      if (plusBtn) {
        plusBtn.disabled = hitLimit || !active;
      }
    });

    this.updateProductsProperty();
  }

  bindSubmit() {
    if (!this.form) return;
    this.form.addEventListener("submit", this.onSubmit);
  }

  async onSubmit(event) {
    const cartComponent = document.querySelector("cart-component");
    if (!cartComponent) return;

    event.preventDefault();

    if (this.submitButton?.disabled) return;

    const formData = new FormData(this.form);
    const cartDrawerSectionId = cartComponent.dataset.sectionId || "cart-drawer";
    formData.set("sections", `cart-badge,${cartDrawerSectionId}`);
    formData.set("sections_url", window.location.pathname);

    this.submitButton.classList.add("loading");
    this.submitButton.disabled = true;
    this.submitButton.setAttribute("aria-busy", "true");

    try {
      await cartComponent.add(formData);
    } finally {
      this.submitButton.classList.remove("loading");
      this.submitButton.setAttribute("aria-busy", "false");
      this.updateUI();
    }
  }
}

if (!customElements.get("bundle-box")) {
  customElements.define("bundle-box", BundleBox);
}